export default "__VITE_ASSET__DKS4HtMf__"